import axios from "./axios";

export const login = async (email, password) => {
  return await axios.post("/auth/login", { email, password });
};

export const refreshToken = async (refreshToken) => {
  return await axios.post("/auth/refresh-token", { refreshToken });
};
